// extracted by mini-css-extract-plugin
export default {"option_count":"CounterOption_option_count__83kgb"};